import React, { useState } from "react";
import validator from "validator";
import "./Login.css";
import Button from "../UIComponents/Button";
import InputField from "../UIComponents/InputField";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import { servicePost } from "../../helper/api";
import ReCAPTCHA from "react-google-recaptcha";

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShownicon, setPasswordShownicon] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [reqLoader, setReqLoader] = useState(false);
  const togglePassword = () => {
    setPasswordShown(!passwordShown);
    setPasswordShownicon(!passwordShownicon);
  };

  // verify recaptcha functionality
  const [isVerifyCaptcha, setIsVerifyCaptcha] = useState(false);

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = loginData;

  const loginHandler = (e) => {
    const { name, value } = e.target;
    setLoginData((preVal) => {
      return {
        ...preVal,
        [name]: value,
      };
    });
  };

  const navigate = useNavigate();

  const loginReqHandler = async () => {
    if (loginData.email == "" || loginData.password == "") {
      setError(true);
      //alert("error");
      setErrorMessage("Please enter all fields.");
      setTimeout(() => {
        setError(false);
        setErrorMessage("");
        setIsLoading(false);
      }, 5000);
      return;
    }

    if (!isVerifyCaptcha) {
      setError(true);
      setErrorMessage("Please check verify captcha.");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
      return;
    }

    if (
      validator.isStrongPassword(loginData.password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
    } else {
      setError(true);
      setErrorMessage("Please, enter valid password");
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
      }, 5000);
      return;
    }

    try {
      setIsLoading(true);
      // if (!isVerify) {
      //   setButtonDes(false);
      //   setError(true);
      //   setErrorMessage("Please check verify captcha.");
      //   setTimeout(() => {
      //     setButtonDes(true);
      //     setError(false);
      //     setErrorMessage("");
      //     setIsLoading(false);
      //   }, 5000);
      //   return;
      // }

      setReqLoader(true);
      const loginUser = await servicePost("adminauth/login", loginData);

      if (loginUser) {
        localStorage.setItem("wealth_user", JSON.stringify(loginUser));

        localStorage.setItem("token", loginUser?.token);

        // const getLogin = await servicePost("api/v1/addnew/activity", {
        //   ipaddress: ipAddress,
        //   userId: loginUser?.data.Account_Id,
        //   time: new Date(),
        //   useragent: `${browserInfo.name}/${browserInfo.version}(${browserInfo.os})`,

        //   activity: "login",
        // });
        let twoFa = loginUser?.twofa;
        setReqLoader(false);
        // if (twoFa === true) {
        //   navigate("/enter-twofa-page");
        // } else {
        //   navigate("/twofaguide");
        // }

        if (
          loginUser.data?.enableOn == true ||
          loginUser.data?.enableOn == "true"
        ) {
          navigate("/enter-twofa");
        } else if (
          (loginUser.data?.enableOn == false ||
            loginUser.data?.enableOn == "false" ||
            loginUser.data?.enableOn == null) &&
          (loginUser.data?.twoFaRequest == true ||
            loginUser.data?.twoFaRequest == "true")
        ) {
          navigate("/enter-twofa");
        } else if (
          loginUser.data?.enableOn == null &&
          loginUser.data?.twoFaRequest == null
        ) {
          navigate("/twofaguide");
        } else {
          navigate("/");
        }
      }
    } catch (error) {
      console.log("err", error?.response?.data?.message);
      setError(true);
      setReqLoader(false);
      setErrorMessage(error?.response?.data?.message);
      setTimeout(() => {
        setErrorMessage("");
        setError(false);
        setIsLoading(false);
      }, 5000);
      return;
    }
  };

  const verifyRecaptchaHandler = async (value) => {
    try {
      if (value === null) {
        setIsVerifyCaptcha(false);
      }
      const verifyToken = await servicePost(
        "adminauth/verifyRecaptcha",
        {
          token: value,
        },
        {}
      );

      console.log("verifyToken", verifyToken);
      if (verifyToken.message == "SUCCESS") {
        setIsVerifyCaptcha(true);
        // setButtonDes(true);
      }
    } catch (error) {
      console.log("error111", error);
      setIsVerifyCaptcha(false);
    }
  };

  //////////////////////////////////////
  return (
    <>
      <Navbar />
      <div className="login-main-wrapper">
        <div className="login-main-wrap container">
          <h3> Welcome to Admin </h3>

          <div className="login-form-main-wrap">
            <div className="login-option">
              <form autoComplete="off">
                <InputField
                  type="text"
                  name="email"
                  id="email"
                  label="Enter your email*"
                  passwordIcon={false}
                  onChange={loginHandler}
                />

                <InputField
                  type={passwordShown ? "text" : "password"}
                  name="password"
                  id="password"
                  label="Enter your password*"
                  passwordIcon={true}
                  togglePassword={togglePassword}
                  iconDisplayed={passwordShownicon}
                  onChange={loginHandler}
                />
                {error ? <div className="error-msg">{errorMessage}</div> : ""}
              </form>
              <div className="login-button login-captcha-btn-wrap">
                <ReCAPTCHA
                  sitekey="6LdduYMjAAAAANl41zEe-rIU6sjjjIv4WDQNo57K"
                  onChange={verifyRecaptchaHandler}
                />
                <Button
                  onClick={loginReqHandler}
                  isLoading={isLoading}
                  label="Continue"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
